import ReferenceService from "@/common/reference.service";
import { ProductService } from '@/common/api.service';
import { SELECT_ANSWER,
    SELECT_NEXT_QUESTION, 
    SELECT_PREV_QUESTION, 
    SUBMIT_QUESTIONS, 
    RESTART_QUESTIONS,
    QUESTIONS_COMPLETE
 } from './actions.type';
import {
    SET_ANSWER,
    SET_QUESTION_FORWARD,
    SET_QUESTION_BACKWARD,
    SET_PRODUCTS,
    RESET_QUESTIONS
} from './mutations.type';
import router from '../router'


const state = {
    activeQuestion: 1,
    questions: [
        {
            number: 1,
            title: 'What type of <em>property</em> do you have?',
            answer: '',
            type: 'image',
            information: '',
            answers: [
                { title: 'Flat', image: 'flat' },
                { title: 'Terrace', image: 'terrace' },
                { title: 'Semi-Detached', image: 'semi-detached' },
                { title: 'Detached', image: 'detached' },
                { title: 'Bungalow', image: 'bungalow' }
            ]
        },
        {
            number: 2,
            title: 'How many <em>bathrooms</em> do you have?',
            answer: '',
            type: 'image',
            information: 'Large properties will need a central heating system that can reach higher heating levels than smaller properties. By telling us how many bedrooms and bathrooms you have, we can get a better understanding about the size of boiler or central heating system you will require.',
            answers: [
                { title: '1', image: 'bathroom' },
                { title: '2', image: 'bathroom' },
                { title: '3', image: 'bathroom' },
                { title: '4+', image: 'bathroom' },
            ]
        },
        {
            number: 3,
            title: 'How many <em>bedrooms</em> do you have?',
            answer: '',
            type: 'image',
            information: 'Large properties will need a central heating system that can reach higher heating levels than smaller properties. By telling us how many bedrooms and bathrooms you have, we can get a better understanding about the size of boiler or central heating system you will require.',
            answers: [
                { title: '1', image: 'bedroom' },
                { title: '2', image: 'bedroom' },
                { title: '3', image: 'bedroom' },
                { title: '4', image: 'bedroom' },
                { title: '5+', image: 'bedroom' },
            ]
        },
        {
            number: 4,
            title: 'What type of <em>fuel</em> do you require?',
            answer: '',
            type: 'image',
            information: '',
            answers: [
                { title: 'Gas', image: 'gas' },
                { title: 'LPG', image: 'lpg' },
                { title: 'Oil', image: 'oil' },
            ]
        },
        {
            number: 5,
            title: 'Do you have a hot <em>water cylinder</em>?',
            answer: '',
            type: 'image',
            information: '',
            answers: [
                { title: 'Yes', image: 'yes' },
                { title: 'Yes, remove it', image: 'removecylinder' },
                { title: 'No', image: 'no' },
                { title: 'Don\'t know', image: 'dontknow' },
            ]
        },
        {
            number: 6,
            title: 'What type of <em>boiler</em> do you require?',
            answer: '',
            type: 'image',
            information: '<h4>Combi</h4><p>This type of boiler removes the need for any stored water, and heats the water instantaneously when you turn the tap on, these boilers are the most popular in the UK today and account for over 80% of installations.</p><h4>System Boiler</h4>Typically this type of boiler would be used for larger properties or new systems, and removes the need for the small heating tank to be installed.<p></p><h4>Regular Boiler</h4><p>Normally used for a like for like replacement of a traditional or conventional boiler, using stored hot water in an airing cupboard.</p>',
            answers: [
                { title: 'Combi', image: 'combi' },
                { title: 'System', image: 'system' },
                { title: 'Regular', image: 'regular' },
            ]
        },
        {
            number: 7,
            title: 'Do you want to move your boiler to a <em>different place</em>?',
            answer: '',
            type: 'image',
            information: '',
            answers: [
                { title: 'Yes', image: 'yes' },
                { title: 'No', image: 'no' }
            ]
        },
        {
            number: 8,
            title: 'Where will your boiler be <em>located</em>?',
            answer: '',
            type: 'image',
            information: '',
            answers: [
                { title: 'The Kitchen', image: 'kitchen' },
                { title: 'The Utility Room', image: 'utility' },
                { title: 'The Loft', image: 'loft' },
                { title: 'An Airing Cupboard', image: 'airing' },
                { title: 'The Garage', image: 'garage' },
                { title: 'Other', image: 'no' }
            ]
        },
        {
            number: 9,
            title: 'Where will your <em>flue exit</em> the property?',
            answer: '',
            type: 'image',
            information: '',
            answers: [
                { title: 'Roof', image: 'flue-roof' },
                { title: 'Wall', image: 'flue-wall' },
            ]
        }
    ],
    tags: [],
    articles: [],
    isLoading: true,
    articlesCount: 0
};

const getters = {
    questions(state) {
        return state.questions
    },
    activeQuestion(state) {
        var activeQuestion = state.questions.find(q => q.number == state.activeQuestion);

        return activeQuestion;
    },
    questionNumber(state) {
        return state.activeQuestion;
    }
}

const actions = {
    [SUBMIT_QUESTIONS]({ commit, state, dispatch }) {

        var payload = {};
        payload.CompanyId = 11;
        payload.SettingId = 1;
        payload.QuoteReference = ReferenceService.getToken();
        payload.PropertyType = state.questions[0].answer;
        payload.Bathrooms = parseInt(state.questions[1].answer);
        payload.Bedrooms = parseInt(state.questions[2].answer);
        payload.FuelType = state.questions[3].answer === 'Gas' ? 1 : state.questions[3].answer === 'LPG' ? 2 : 3;
        payload.WaterCylinder = state.questions[4].answer;
        payload.BoilerType = state.questions[5].answer === 'Combi' ? 1 : state.questions[5].answer === 'System' ? 2 : 3;
        payload.MoveBoilerPosition = state.questions[6].answer === 'Yes' ? true : false;
        payload.BoilerLocation = state.questions[7].answer;
        payload.FlueExit = state.questions[8].answer;

        return ProductService.postAnswers(payload)
            .then(({data}) => {
                commit(SET_PRODUCTS, data.Products, { root: true });
                // Set the questions to complete
                dispatch(QUESTIONS_COMPLETE, null, { root: true });
            })
    },
    [SELECT_ANSWER]({ commit, dispatch }, payload) {
        commit(SET_ANSWER, payload);
        dispatch(SELECT_NEXT_QUESTION);
        //commit(SET_QUESTION_FORWARD)
    },
    async [SELECT_NEXT_QUESTION]({ commit, state, getters, dispatch }) {
        var questionCount = state.questions.length;

        // Has the question been answered?
        if (state.activeQuestion < questionCount) {
            if (state.questions[state.activeQuestion - 1].answer.length > 0) {
                commit(SET_QUESTION_FORWARD);
            } else {
                alert('Answer Question!')
            }
        } else {
            await dispatch(SUBMIT_QUESTIONS);

            if (getters.TakeCustomerDetailsFirst || getters.noProductsFound) {
                // Need to direct user to take customer details if required first
                // Or if no products are found
                router.push({ name: 'Customer' })
            } else {
                // Need to either direct to product page or customer information page
                router.push({ path: 'products' })
            }      
        }   
    },
    [SELECT_PREV_QUESTION]({ commit, state }) {
        if (state.activeQuestion > 1)
            commit(SET_QUESTION_BACKWARD);
    },
    [RESTART_QUESTIONS]({ commit, state}) {
        commit(RESET_QUESTIONS);
        ReferenceService.destroyToken();
    }
}

const mutations = {
    [SET_ANSWER](state, payload) {
        state.questions[state.activeQuestion - 1].answer = payload;
    },
    [SET_QUESTION_FORWARD](state) {
        state.activeQuestion += 1;
    },
    [SET_QUESTION_BACKWARD](state) {
        state.activeQuestion -= 1;
    },
    [RESET_QUESTIONS](state) {
        state.questions.forEach((q) => {
            q.answer = ''
        });
        state.activeQuestion = 1;
    }
}

export default {
    state,
    getters,
    actions,
    mutations
};